module.exports = __webpack_public_path__ + "static/media/suggestion-desktop.030454d3.png";